module.exports = __webpack_public_path__ + "static/media/bg-share-invite.468df049.png";